export default "__VITE_ASSET__DoBjAR$2__"